<script>
  /** @type {{ subhead: string, description: string, sectionNumber: string }} */
  const { subhead, description, sectionNumber } = $props();
</script>

<div class="section-label">Section {sectionNumber}</div>
<h4 class="section-subhead">{subhead}</h4>
<p>{description}</p>
<style>
.section-label {
  color: var(--color-blue);
  font-family: var(--font-family-sans-alt);
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
}
.section-subhead {
  margin-block-start: 0;
}
</style>
